import { Icon } from "./Icon.tsx";

/** "Rename project" icon for icon-only buttons — a plus-like cross, same style as DuplicateIcon.tsx/DownloadIcon.tsx. */
export function RenameIcon() {
  return (
    <Icon>
      <path d="M9 4h6M12 4v16M9 20h6" />
    </Icon>
  );
}
